import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Experience from '../components/Experience';
import CaseStudies from '../components/CaseStudies';
import Publications from '../components/Publications';
import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import NewsWidget from '../components/NewsWidget';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage">
      <Header />
      <Hero />
      <About />
      <Services />
      <Experience />
      <CaseStudies />
      <Publications />
      <Testimonials />
      <Blog />
      <NewsWidget />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
